module.exports = __webpack_public_path__ + "ffc407acaae1813da082f2b76024ad68.pdf";